

































































































import {
  LiveManagementLivecarpDTO,
  LiveManagementLiveService,
} from "@/common/api";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import PaginateModel from "@/model/paginate";
import Multiselect from "vue-multiselect";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LiveListComponent",
  components: {
    QMultiSelect,
    QSearch,
    QPaginate,
    QTableHeader,
    Multiselect,
  },
})
export default class LiveListComponent extends Vue {
  public liveCarps: LiveManagementLivecarpDTO[] = [];

  public filter = {
    status: [],
    title: "",
    sort: "start_datetime",
    direction: "desc",
    perPage: 30,
    page: 1,
  };

  public headers = [
    { id: "start_datetime", name: "開催日時", order: "desc" },
    { id: "end_datetime", name: "終了日時", order: "" },
    { id: "user_created.name", name: "作成者" },
    { id: "title", name: "タイトル" },
    { id: "open_status", name: "状態", order: "" },
    { id: "", name: "" },
  ];

  public status = [
    { id: "edit", name: "編集中" },
    { id: "waiting", name: "公開待ち" },
    { id: "opening", name: "公開中" },
    { id: "bidding", name: "入札中" },
    { id: "closed", name: "入札終了" },
    { id: "cancel", name: "中止" },
  ];

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public resetSearch() {
    this.filter.status = [];
    this.filter.title = "";
    this.search();
  }

  public mounted() {
    const currentQuery = this.$router.currentRoute.query;

    if (currentQuery.status) {
      const status = currentQuery.status;
      if (typeof status === "string") {
        this.filter.status = [currentQuery.status];
      } else if (typeof status === "object") {
        this.filter.status = currentQuery.status as string[];
      }
    }

    if (currentQuery.direction) {
      this.filter.direction = String(currentQuery.direction);
    }

    if (currentQuery.sort) {
      this.filter.sort = String(currentQuery.sort);
    }

    if (currentQuery.page) {
      this.filter.page = Number(currentQuery.page);
    }

    if (currentQuery.title) {
      this.filter.title = String(currentQuery.title);
    }

    this.init();
  }

  public init() {
    let query: any = {
      title: this.filter.title,
      page: this.filter.page,
      sort: this.filter.sort,
      direction: this.filter.direction,
      status: this.filter.status.join(","),
    };

    query = {
      ...query,
      status: this.filter.status,
    };

    this.getLiveCarp(query);
  }

  public search(query: any = {}) {
    const newQuery = {
      title: this.filter.title,
      page: this.filter.page,
      sort: this.filter.sort,
      direction: this.filter.direction,
      status: this.filter.status,
      ...query,
    };

    this.$router.push({ query: newQuery });

    query = {
      ...this.filter,
      ...query,
    };

    this.getLiveCarp(query);
  }

  public async getLiveCarp(query) {
    try {
      const result = await LiveManagementLiveService.adminLive(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });

      this.filter.page = result.data.paginator.currentPage;
      this.liveCarps = result.data.livecarp;
    } catch (error) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }
}
